var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55273 24.9994C3.55273 33.4884 8.48621 40.8246 15.6401 44.3011L5.40957 16.2712C4.21956 18.9385 3.55273 21.8902 3.55273 24.9994Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.48 23.9172C39.48 21.2667 38.5279 19.4311 37.7113 18.0024C36.6241 16.2358 35.6051 14.7398 35.6051 12.9732C35.6051 11.0017 37.1004 9.16653 39.2066 9.16653C39.3017 9.16653 39.3919 9.17837 39.4845 9.18367C35.6688 5.688 30.5851 3.55371 25.0016 3.55371C17.5089 3.55371 10.9169 7.39789 7.08203 13.2205C7.58521 13.2356 8.05942 13.2462 8.46221 13.2462C10.7055 13.2462 14.178 12.974 14.178 12.974C15.3342 12.9058 15.4705 14.6039 14.3155 14.7406C14.3155 14.7406 13.1537 14.8773 11.8608 14.945L19.671 38.1754L24.3645 24.0992L21.023 14.9442C19.8681 14.8765 18.774 14.7398 18.774 14.7398C17.6183 14.672 17.7538 12.905 18.9095 12.9732C18.9095 12.9732 22.4514 13.2454 24.5588 13.2454C26.8017 13.2454 30.2746 12.9732 30.2746 12.9732C31.4315 12.905 31.5674 14.6031 30.4121 14.7398C30.4121 14.7398 29.2478 14.8765 27.9574 14.9442L35.708 37.9987L37.8472 30.8502C38.7744 27.8838 39.48 25.7532 39.48 23.9172Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3763 26.8755L18.9414 45.5736C20.8627 46.1384 22.8946 46.4473 25 46.4473C27.4976 46.4473 29.8927 46.0156 32.1221 45.2316C32.0646 45.1398 32.0123 45.0423 31.9695 44.9362L25.3763 26.8755Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8207 14.71C43.9129 15.3931 43.9651 16.1264 43.9651 16.9153C43.9651 19.0916 43.5587 21.5381 42.3344 24.5971L35.7832 43.5376C42.1593 39.8195 46.448 32.9118 46.448 24.9999C46.4484 21.2712 45.4959 17.7649 43.8207 14.71Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0008 0C11.2157 0 0 11.2146 0 24.9994C0 38.7858 11.2157 50 25.0008 50C38.7855 50 50.0029 38.7858 50.0029 24.9994C50.0024 11.2146 38.7855 0 25.0008 0ZM25.0008 48.8541C11.8479 48.8541 1.14634 38.1528 1.14634 24.9994C1.14634 11.8468 11.8475 1.14632 25.0008 1.14632C38.1534 1.14632 48.8541 11.8468 48.8541 24.9994C48.8541 38.1528 38.1534 48.8541 25.0008 48.8541Z",
    fill: "#21759B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.357745c31e172aec5b1706e0c3f1617f.svg";
export { ForwardRef as ReactComponent };